import Page from "./index";

export default { path: "/home/system/user", component: Page };
